import { Elena, html, nothing } from "../../index.js";

/** ░█ [ELENA]: Button component */
export default class Button extends Elena(HTMLElement) {
  static tagName = "button-default";
  static props = ["variant", "id"];

  variant = "default";
  id = '';

  render() {
    return html`
      <button class="button ${this.variant}"${this.id ? html` id="${this.id}"` : nothing}>
        ${this.text}
      </button>
    `;
  }
}

Button.define();
